import { createEventHook } from '@vueuse/core'
import { computed } from 'vue'

import { useUserPropertiesCountriesAndNationalitiesQuery, type UserPropertiesCountriesAndNationalitiesQuery } from '@/gql/myomr'

type Country = UserPropertiesCountriesAndNationalitiesQuery['userPropertiesPreferences']['countries'][number]

const onLoadHook = createEventHook<[Country[]]>()

export function useCountriesAndNationalitiesData() {
  const { result: userPropertiesResult, onResult } = useUserPropertiesCountriesAndNationalitiesQuery({ fetchPolicy: 'cache-first' })
  const countries = computed(() =>
    [...(userPropertiesResult.value?.userPropertiesPreferences.countries ?? [])].sort((a, b) => a.translation.localeCompare(b.translation)),
  )

  const getCountryCodeFromAirtableData = (airtableValue: string) => {
    return countries.value.find((c) => c.translations.de == airtableValue)?.code
  }
  const getAirtableDataFromCountryCode = (countryCode: string) => {
    return countries.value.find((c) => c.code == countryCode)?.translations.de
  }

  onResult((data) => {
    onLoadHook.trigger(data?.data?.userPropertiesPreferences?.countries ?? [])
  })

  return {
    countries,

    onLoad: onLoadHook.on,

    getCountryCodeFromAirtableData,
    getAirtableDataFromCountryCode,
  }
}
